import React from 'react';
import VERSION_INFO from '../../version';
import './footer.css';

const Footer = () => {
    return (
        <footer className="app-footer">
            <div className="footer-content">
                <span className="footer-text">
                    © {new Date().getFullYear()} InnovateMore LLC. All rights reserved.
                </span>
                <span className="footer-version">
                    Version {VERSION_INFO.version} ({VERSION_INFO.environment})
                </span>
            </div>
        </footer>
    )
}

export default Footer